<template>
  <v-dialog v-model="dialog" width="800" persistent>
    <v-card class="py-5">
      <v-card-title
        class="add-product-modal__head"
        :class="{ 'justify-space-between': !breakpointXs, 'justify-center': breakpointXs }"
      >
        <div class="add-product-modal__head--title fw-100">
          Please fix following errors to successfully generate flatfile
        </div>
        <div class="justify-end">
          <v-btn icon @click="$emit('close-no-client-modal', true)">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-row class="no-gutters fill-height">
        <v-col :xs="12" :sm="12" :md="12" :lg="12" class="fill-height margin-auto">
          <div class="my-3">
            <v-alert border="left" class="mx-10" v-for="error in errors" :key="error.message" type="error">
              {{ error.error }}
            </v-alert>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "FlatFileErrorModal",
  components: {
    // GauravImpexLogo
  },
  data() {
    return {
      dialog: true
    };
  },
  props: {
    errors: {
      type: Array,
      default: null
    }
  },
  mixins: [commonMethodsMixin],
  methods: {}
};
</script>
<style lang="scss">
.login-container {
  margin: auto;

  .description {
    font-size: 1.3rem;
    font-weight: 600;
  }

  .form-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.import-coming-soon .margin-auto {
  margin: auto;
}
</style>
